function stripHtmlTags(text) {
  if (!text) return '';
  return text.replace(/(<([^>]+)>)/gi, '');
}

export default stripHtmlTags;
